import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, X } from "lucide-react";
import { api } from "@/lib/api";

export function HeaderSearch() {
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(0);
  const [expanded, setExpanded] = useState(false);
  const box = useRef(null);
  const input = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (q.trim().length < 2) { setRes(null); return; }
    const t = setTimeout(() => api.get("/search", { params: { q } }).then((r) => { setRes(r.data); setActive(0); }).catch(() => {}), 220);
    return () => clearTimeout(t);
  }, [q]);
  useEffect(() => {
    const close = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const items = res ? [...res.teams.map((t) => ({ key: `t${t.id}`, to: `/teams/${t.id}`, img: t.logo, title: t.name, sub: "Team", testid: `search-team-${t.id}` })),
    ...res.players.map((p) => ({ key: `p${p.id}`, to: `/player/${p.id}`, img: p.photo, title: p.name, sub: [p.team, p.position].filter(Boolean).join(" · ") || "Player", testid: `search-player-${p.id}` }))] : [];
  const go = (it) => { setOpen(false); setExpanded(false); setQ(""); navigate(it.to); };
  const toggle = () => { if (!expanded) setTimeout(() => input.current?.focus(), 30); setExpanded(!expanded); };
  const onKey = (e) => {
    if (e.key === "ArrowDown") { e.preventDefault(); setActive((a) => Math.min(a + 1, items.length - 1)); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setActive((a) => Math.max(a - 1, 0)); }
    else if (e.key === "Escape") { setOpen(false); setExpanded(false); }
  };

  return (
    <>
    <button type="button" className="nbc-search-toggle" onClick={toggle} aria-label={expanded ? "Close search" : "Search"} aria-expanded={expanded} data-testid="header-search-toggle">
      {expanded ? <X size={20} /> : <Search size={20} />}
    </button>
    <div className={`nbc-search ${expanded ? "expanded" : ""}`} ref={box} data-testid="header-search">
      <form role="search" onSubmit={(e) => { e.preventDefault(); if (items[active]) go(items[active]); }}>
        <Search size={16} aria-hidden="true" />
        <input ref={input} value={q} onChange={(e) => { setQ(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)} onKeyDown={onKey}
          placeholder="Search teams, players…" aria-label="Search teams and players" data-testid="header-search-input" />
      </form>
      {open && res && (
        <div className="nbc-search-results" role="listbox" data-testid="header-search-results">
          {items.map((it, i) => (
            <button key={it.key} type="button" role="option" aria-selected={i === active} className={i === active ? "active" : ""}
              onMouseEnter={() => setActive(i)} onClick={() => go(it)} data-testid={it.testid}>
              <img src={it.img} alt="" loading="lazy" onError={(e) => { e.currentTarget.style.visibility = "hidden"; }} />
              <span><strong>{it.title}</strong><small>{it.sub}</small></span>
            </button>
          ))}
          {!items.length && <p data-testid="header-search-empty">No teams or players found.</p>}
        </div>
      )}
    </div>
    </>
  );
}
